<template>
  <div class="option-product-caption__initial-input-input-container">
    <input
      :name="captionValueInputName"
      v-model.trim="captionValue"
      type="hidden"
    >
    <input
      :name="captionInitialInputName('f')"
      v-model.trim="firstInitial"
      :required="true"
      placeholder="F"
      type="text"
      maxlength="1"
      class="option-product-caption__initial-input js-caption-input"
      @focus="handleInputFocus"
    >
    <input
      :name="captionInitialInputName('l')"
      v-model.trim="lastInitial"
      :required="true"
      placeholder="L"
      type="text"
      maxlength="1"
      class="option-product-caption__initial-input option-product-caption__initial-input--large js-caption-input"
      @focus="handleInputFocus"
    >
    <input
      :name="captionInitialInputName('m')"
      v-model.trim="middleInitial"
      :required="true"
      placeholder="M"
      type="text"
      maxlength="1"
      class="option-product-caption__initial-input js-caption-input"
      @focus="handleInputFocus"
    >
  </div>
</template>

<script>
import GoogleAnalytics from '@Shared/lib/google-analytics'

export default {
  name: 'InitialsInput',
  props: {
    optionProductCaption: { type: Object, default: null, required: true },
    optionProduct: { type: Object, default: null, required: true }
  },
  data () {
    return {
      captionValue: '',
      firstInitial: '',
      middleInitial: '',
      lastInitial: ''
    }
  },
  computed: {
    captionValueInputName () {
      return `Caption_${this.optionProduct.CatalogPackageOptionProductID}_${this.optionProductCaption.CaptionId}`
    },
    captionPlaceHolder () {
      if (this.optionProductCaption.Placeholder !== null) {
        return `Example: ${this.optionProductCaption.Placeholder}`
      }
    }
  },
  watch: {
    firstInitial (v, ov) {
      this.captionValue = `${this.firstInitial}${this.lastInitial}${this.middleInitial}`
    },
    middleInitial (v, ov) {
      this.captionValue = `${this.firstInitial}${this.lastInitial}${this.middleInitial}`
    },
    lastInitial (v, ov) {
      this.captionValue = `${this.firstInitial}${this.lastInitial}${this.middleInitial}`
    }
  },
  mounted () {
    const configuredText = this.$store.getters.getConfiguredValue(this.captionValueInputName)

    if (configuredText !== null && configuredText.length > 0) {
      this.firstInitial = configuredText.charAt(0)
    }

    if (configuredText !== null && configuredText.length > 1) {
      this.lastInitial = configuredText.charAt(1)
    }

    if (configuredText !== null && configuredText.length > 2) {
      this.middleInitial = configuredText.charAt(2)
    }
  },
  methods: {
    captionInitialInputName (inputSuffix) {
      return `Caption_${this.optionProduct.CatalogPackageOptionProductID}_${this.optionProductCaption.CaptionId}_${inputSuffix}`
    },
    handleInputFocus () {
      GoogleAnalytics.trackEvent(
        'Option Product Caption',
        'focus',
        this.optionProductCaption.CaptionLabel
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/option-product.scss';

.option-product-caption {
  margin-bottom: 10px;

  &__initial-input {
    &-container {
      display: flex;
      align-items: center;
    }

    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #c2c2c2;
    color: #555;
    font-size: 16px;
    line-height: 1.42857143;
    margin-right: 5px !important;
    padding: 12px 12px;
    width: 40px !important;

    &::placeholder {
      color: #969696;
    }

    &:focus {
      border-color: $letterjacket-color-blue;
      outline: 0;
    }

    &--large {
      width: 50px !important;
      height: 60px !important;
      padding: 18px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/PackageOptions/OptionProduct/CaptionInputs/InitialsInput.vue